import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-loading',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProgressSpinnerModule],
  template: ` @if (isLoading()) {
    <div class="absolute top-0 left-0 w-full h-full bg-white/40 z-[999999] flex justify-center">
      <div class="pt-50">
        <p-progress-spinner ariaLabel="loading" />
      </div>
    </div>
  }`,
  styles: ``,
})
export class LoadingComponent {
  private readonly loadingService = inject(LoadingService);
  readonly isLoading = this.loadingService.isLoading;
}
